import { EMAIL_REGEXP } from '@/constants';
import digestMessage from '@/hooks/context/EventCollector/hash';
import BaseEvent, { BaseGetEvent, IBaseEvent } from './BaseEvent';

export interface ITextInputEvent extends IBaseEvent {
  type: 'input';
  isEmail: boolean;
  toJSON(): BaseGetEvent & {
    type: ITextInputEvent['type'];
    value: string | number;
  };
  getHash(): Promise<string>;
}

export default class TextInputEvent
  extends BaseEvent
  implements ITextInputEvent
{
  type = 'input' as const;

  private value: string | number;

  constructor({
    description,
    value,
  }: {
    description: string;
    value: string | number;
  }) {
    super(description);
    this.value = value;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      value: this.value,
    };
  }

  get isEmail() {
    if (typeof this.value === 'number') return false;
    return EMAIL_REGEXP.test(this.value);
  }

  async getHash() {
    return digestMessage(this.value as string);
  }
}
